export interface FetchError {
    code: number,
    message: string
}

export function isFetchError(obj: any): obj is FetchError {
    return typeof obj != 'undefined' && typeof (obj as FetchError).code !== 'undefined';
}